import infraConfig from './config';
import {
    restQuery,
    QueryResult,
    BaseModel,
    restMutation,
    MutationResult,
} from 'vue-apollo-model';

export interface QueryInfo {
    app_id: string;
    scope: string;
    redirect_uri: string;
    state: string;
    size?: string;
    href?: string;
}
export class QrCodeModel extends BaseModel {
    @restQuery<QrCodeModel>({
        url: `${infraConfig.infraBaseUrl}/oauth2/app_info/name`,
        method: 'get',
        variables($route) {
            return {
                appId: $route.query.app_id,
            };
        },
    })
    appNameQuery!: QueryResult<Record<string, string>>;

    get appName() {
        return this.appNameQuery.data.appName;
    }
}

export interface StartMutationResParams {
    qrType: string;
    kpn: string;
    serviceOwnParams: string;
}

export interface StartMutationRes extends CommonRes {
    next: string;
    expireTime: number;
    qrLoginSignature: string;
    imageData: string;
    qrLoginToken: string;
}

export interface AcceptError extends CommonRes {
    error_msg: string;
}

export interface ScanMutationRes extends CommonRes {
    next: string;
    qrLoginSignature: string;
}

export interface AcceptMutationRes extends CommonRes {
    serviceOwnToken: string;
}

export interface QrInfo {
    qrLoginToken: string;
    qrLoginSignature: string;
}

export interface CommonRes {
    result: number;
}
